import { defineComponent as _defineComponent } from 'vue';
import {} from "axios";
import { BModal } from "bootstrap-vue";
import { computed, ref } from "vue";
import {} from "@/api/schema";
export default /*#__PURE__*/ _defineComponent({
    __name: 'OperationErrorDialog',
    props: {
        operationError: null
    },
    emits: ["hide"],
    setup(__props, { emit }) {
        const props = __props;
        const show = ref(() => props.operationError != null);
        const isPartialSuccess = computed(() => {
            var _a, _b;
            return ((_b = (_a = props.operationError) === null || _a === void 0 ? void 0 : _a.result) === null || _b === void 0 ? void 0 : _b.success_count) > 0;
        });
        const success_count = computed(() => {
            var _a, _b;
            return ((_b = (_a = props.operationError) === null || _a === void 0 ? void 0 : _a.result) === null || _b === void 0 ? void 0 : _b.success_count) || 0;
        });
        const error_count = computed(() => {
            var _a, _b;
            return ((_b = (_a = props.operationError) === null || _a === void 0 ? void 0 : _a.result) === null || _b === void 0 ? void 0 : _b.errors.length) || 0;
        });
        const reasons = computed(() => {
            var _a, _b, _c, _d;
            if (props.operationError && props.operationError.result) {
                return [...new Set(props.operationError.result.errors.map((e) => e.error))];
            }
            const response_error = (_d = (_c = (_b = (_a = props.operationError) === null || _a === void 0 ? void 0 : _a.errorMessage) === null || _b === void 0 ? void 0 : _b.response) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.err_msg;
            if (response_error) {
                return [response_error];
            }
            return [];
        });
        const title = computed(() => {
            return isPartialSuccess.value ? "Some items could not be processed" : "Something went wrong...";
        });
        const titleVariant = computed(() => {
            return isPartialSuccess.value ? "warning" : "danger";
        });
        const errorMessage = computed(() => {
            var _a, _b;
            return (_b = (_a = props.operationError) === null || _a === void 0 ? void 0 : _a.errorMessage) === null || _b === void 0 ? void 0 : _b.message;
        });
        function onHide() {
            emit("hide");
        }
        return { __sfc: true, props, emit, show, isPartialSuccess, success_count, error_count, reasons, title, titleVariant, errorMessage, onHide, BModal };
    }
});
